import React from 'react';
import { connect } from 'react-redux';
import { Route, Redirect, Switch } from 'react-router-dom';

// Project imports
import Tabs, { Tab } from '../../components/Tabs';
import { rolesList } from '../../redux/auth';

// Module imports
import Historic from './pages/Historic';
import RealTime from './pages/RealTime';

import { Wrapper } from './styles';
import SubHeaderSecondary from '../../components/SubHeaderSecondary';

const Dashboard = ({ match, roles, location, history }) => {
  const isAdmin = roles.indexOf(rolesList.ADMINISTRATOR) !== -1;
  const tabs = [];

  if (isAdmin || roles.indexOf(rolesList.DASHBOARD_HISTORY) !== -1) {
    tabs.push({
      text: 'Histórico',
      path: `${match.path}/historico`,
      component: Historic,
    });
  }

  if (isAdmin || roles.indexOf(rolesList.DASHBOARD_ONGOING) !== -1) {
    tabs.push({
      text: 'Tempo real',
      path: `${match.path}/tempo-real/:id`,
      component: RealTime,
    });
  }

  const _renderTabs = () => (
    <Tabs>
      {tabs.map(tab => (
        <Tab
          isActive={tab.path === location.pathname}
          onClick={() => history.push(tab.path)}
          key={tab.path}
        >
          {tab.text}
        </Tab>
      ))}
    </Tabs>
  );

  const _renderRoutes = () => (
    <Switch>
      {tabs.map(tab => (
        <Route path={tab.path} component={tab.component} key={tab.path} />
      ))}
      {/* default tab */}
      <Redirect to={tabs[0].path} />
    </Switch>
  );

  return (
    <Wrapper>
      <SubHeaderSecondary title="Dashboard" renderSide={_renderTabs} currentTab={location.pathname} />
      {_renderRoutes()}
    </Wrapper>
  );
};

// Redux

const mapStateToProps = state => ({ roles: state.auth.roles });

export default connect(mapStateToProps)(Dashboard);
